module.exports = __webpack_public_path__ + "static/creating_pathways-45783374865c1e368732a1128383bb69.png";